import React, { useState } from "react";
import styles from "./LOSTreeViewPage.module.css";
import treeViewSelected from "./images/tree-view-selected.png";
import treeViewUnselected from "./images/tree-view-unselected.png";
import branchViewSelected from "./images/branch-view-selected.png";
import branchViewUnselected from "./images/branch-view-unselected.png";
import listViewSelected from "./images/list-view-selected.png";
import listViewUnselected from "./images/list-view-unselected.png";
import LOSTreeView from "./../../components/LOSTreeView";
import LOSBranchView from "./../../components/LOSBranchView";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LOSTreeViewPage = () => {
  const {t} = useTranslation();
  const [view, setView] = useState("tree");
  const history = useHistory();
  const config = {
    ROOT_NODE_COLOR: "#9E703C",
    PARENT_NODE_COLOR: "#91B6BB",
    CHILD_NODE_COLOR: "#A89C96",
    LINK_COLOR: "#91B6BB",
    TEXT_COLOR: "#ffffff",
    FONT_SIZE: "12px",
  };

  const data = {
    id: 1,
    name: "Jeff & Britt Scott",
    connections: [
      {
        id: 2,
        name: "Jason Barr",
        connections: [
          {
            id: 3,
            name: "Angela & Bennet Bennet",
            connections: [
              {
                id: 4,
                name: "Liam Johnson",
                connections: [],
              },
              {
                id: 5,
                name: "Rachel Adams",
                connections: [],
              },
            ],
          },
          {
            id: 6,
            name: "Jeremy Price",
            connections: [
              {
                id: 7,
                name: "Sophia Green",
                connections: [],
              },
            ],
          },
        ],
      },
      {
        id: 8,
        name: "Yuan Cho",
        connections: [
          {
            id: 9,
            name: "Paul Brown",
            connections: [],
          },
          {
            id: 10,
            name: "Henry Lee",
            connections: [
              {
                id: 11,
                name: "Maria Perez",
                connections: [],
              },
              {
                id: 12,
                name: "David Clark",
                connections: [],
              },
              {
                id: 13,
                name: "Chris Martinez",
                connections: [
                  {
                    id: 14,
                    name: "Ella Lewis",
                    connections: [],
                  },
                  {
                    id: 15,
                    name: "Mason Walker",
                    connections: [],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 16,
        name: "Olivia Taylor",
        connections: [
          {
            id: 17,
            name: "James Miller",
            connections: [
              {
                id: 18,
                name: "Isabella Davis",
                connections: [],
              },
            ],
          },
          {
            id: 19,
            name: "Lucas White",
            connections: [],
          },
        ],
      },
      {
        id: 20,
        name: "Maria Rodriguez",
        connections: [],
      },
    ],
  };

  const toggleView = () => {
    setView(view === "tree" ? "branch" : "tree");
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>{t("LOS Tree View")}</h1>
      </header>
      <div className={styles.buttonRow}>
        <div className={styles.listButton}></div>
        <div className={styles.circleButtons}>
          <button
            className={styles.circleButton}
            onClick={() => history.push("/los-branch-view")}
          >
            <img
              src={
                view === "branch" ? branchViewSelected : branchViewUnselected
              }
              alt="Branch View"
              className={styles.buttonImage}
            />
          </button>
          <button
            className={styles.circleButton}
            onClick={() => history.push("/los-tree-view")}
          >
            <img
              src={view === "tree" ? treeViewSelected : treeViewUnselected}
              alt="Tree View"
              className={styles.buttonImage}
            />
          </button>
        </div>
        <div className={styles.listButton}>
          <div className={styles.line}>&nbsp;</div>
          <button
            className={styles.circleButton}
            onClick={() => history.push("/los")}
          >
            <img src={listViewUnselected} className={styles.buttonImage} />
          </button>
        </div>
      </div>
      <main className={styles.viewContent}>
        <LOSBranchView data={data} config={config} />
      </main>
    </div>
  );
};

export default LOSTreeViewPage;
